import React, { useState } from "react"
import { ErrorMessage, Field, Form, Formik } from "formik"
import { Col, Container, Modal, Row } from "react-bootstrap"
import smile from "../../../images/smile.png"
import userIcon from "../../../images/icons8-user-24.png"
import emailIcon from "../../../images/icons8-email-24.png"
import phoneIcon from "../../../images/icons8-ringing-phone-24.png"
import textIcon from "../../../images/icons8-document-24.png"
import { MobileButton } from "../button/button"
import { InputStyled, ContactFormStyled, ModalStyled } from "./contactFormStyle"
import * as Yup from "yup"
import iconAttachment from "../../../images/icon-attach.png"
import amountIcon from "../../../images/amount-icon.png"
import iconCity from "../../../images/building.png"
import Dropzone from "react-dropzone"
import { injectIntl } from "gatsby-plugin-intl"

const ContactForm = ({
  careerView,
  build,
  investorsView,
  job,
  refferer,
  id,
  landPurchaseView,
  gwView,
  intl,
}) => {
  const [formConfirmation, setFormConfirmation] = useState(false)
  const handleShowFormConfimation = () => {
    setFormConfirmation(true)
  }
  const handleCloseFormConfirmation = () => {
    setFormConfirmation(false)
  }
  const [fileName, addFileName] = useState(false)
  const [fileAdress, setFileAdress] = useState(false)

  const ContactSchema = Yup.object().shape({
    name: Yup.string()
      .min(5, intl.formatMessage({ id: "form.error.tooShort" }))
      .max(50, intl.formatMessage({ id: "form.error.tooLong" }))
      .required(intl.formatMessage({ id: "form.error.name" })),
    email: Yup.string()
      .email(intl.formatMessage({ id: "form.error.mail" }))
      .required(intl.formatMessage({ id: "form.error.mail" })),
    phone: Yup.number()
      .typeError(intl.formatMessage({ id: "form.error.tel" }))
      .required(intl.formatMessage({ id: "form.error.tel" })),
    message: Yup.string()
      .max(500, intl.formatMessage({ id: "form.error.tooLong" }))
      .required(intl.formatMessage({ id: "form.error.message" })),
    // rodo: Yup.mixed().test("isAccepted", "Zgoda jest wymagana", value => {
    //   return value === true
    // }),
    // rodo1: Yup.mixed().test("isAccepted", "Zgoda jest wymagana", value => {
    //   return value === true
    // }),
  })
  const InvestorsSchema = Yup.object().shape({
    name: Yup.string()
      .min(5, intl.formatMessage({ id: "form.error.tooShort" }))
      .max(50, intl.formatMessage({ id: "form.error.tooLong" }))
      .required(intl.formatMessage({ id: "form.error.name" })),
    email: Yup.string()
      .email(intl.formatMessage({ id: "form.error.mail" }))
      .required(intl.formatMessage({ id: "form.error.mail" })),
    phone: Yup.number()
      .typeError(intl.formatMessage({ id: "form.error.tel" }))
      .required(intl.formatMessage({ id: "form.error.tel" })),
    amount: Yup.string().required(
      intl.formatMessage({ id: "form.error.amount" })
    ),
    message: Yup.string().required(
      intl.formatMessage({ id: "form.error.message" })
    ),
    // rodo: Yup.mixed().test("isAccepted", "Zgoda jest wymagana", value => {
    //   return value === true
    // }),
    // rodo1: Yup.mixed().test("isAccepted", "Zgoda jest wymagana", value => {
    //   return value === true
    // }),
  })
  const LandPurchaseSchema = Yup.object().shape({
    name: Yup.string()
      .min(5, intl.formatMessage({ id: "form.error.tooShort" }))
      .max(50, intl.formatMessage({ id: "form.error.tooLong" }))
      .required(intl.formatMessage({ id: "form.error.name" })),
    email: Yup.string()
      .email(intl.formatMessage({ id: "form.error.mail" }))
      .required(intl.formatMessage({ id: "form.error.mail" })),
    phone: Yup.number()
      .typeError(intl.formatMessage({ id: "form.error.tel" }))
      .required(intl.formatMessage({ id: "form.error.tel" })),
    street: Yup.string()
      .typeError(intl.formatMessage({ id: "form.error.street" }))
      .required(intl.formatMessage({ id: "form.error.street" })),
    city: Yup.string()
      .typeError(intl.formatMessage({ id: "form.error.city" }))
      .required(intl.formatMessage({ id: "form.error.city" })),
    message: Yup.string().required(
      intl.formatMessage({ id: "form.error.message" })
    ),
    // rodo: Yup.mixed().test("isAccepted", "Zgoda jest wymagana", value => {
    //   return value === true
    // }),
    // rodo1: Yup.mixed().test("isAccepted", "Zgoda jest wymagana", value => {
    //   return value === true
    // }),
  })
  const ApplicationSchema = Yup.object().shape({
    name: Yup.string()
      .min(5, intl.formatMessage({ id: "form.error.tooShort" }))
      .max(50, intl.formatMessage({ id: "form.error.tooLong" }))
      .required(intl.formatMessage({ id: "form.error.name" })),
    email: Yup.string()
      .email(intl.formatMessage({ id: "form.error.mail" }))
      .required(intl.formatMessage({ id: "form.error.mail" })),
    // rodo: Yup.mixed().test("isAccepted", "Zgoda jest wymagana", value => {
    //   return value === true
    // }),
    // rodo1: Yup.mixed().test("isAccepted", "Zgoda jest wymagana", value => {
    //   return value === true
    // }),
    phone: Yup.number()
      .typeError(intl.formatMessage({ id: "form.error.tel" }))
      .required(intl.formatMessage({ id: "form.error.tel" })),
    file: Yup.mixed()
      .required(intl.formatMessage({ id: "form.error.cv" }))
      .test(
        "fileFormat",
        intl.formatMessage({ id: "form.error.cv.format" }),
        value => {
          return (
            value &&
            [
              "application/pdf",
              "application/msword",
              "application/vnd.oasis.opendocument.text",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ].includes(value.type)
          )
        }
      )
      .test(
        "fileSize",
        intl.formatMessage({ id: "form.error.cv.size" }),
        value => {
          return value && value.size < 5000000
        }
      ),
  })
  const onDropFiles = acceptedFiles => {
    console.log(acceptedFiles)
    acceptedFiles && addFileName(acceptedFiles.name)
    let formDataFile = new FormData()
    formDataFile.append("thefile", acceptedFiles)
    console.log(formDataFile)
    acceptedFiles &&
      fetch("https://willbud.pl/file.php", {
        method: "POST",
        body: formDataFile,
      })
        .then(response => {
          return response.text()
        })
        .then(data => {
          setFileAdress(`https://willbud.pl/${data}`)
        })
  }

  return (
    <ContactFormStyled careerView={careerView}>
      <Formik
        initialValues={{
          name: "",
          email: "",
          phone: "",
          amount: "",
          message: "",
          street: "",
          city: "",
          file: "",
          job: job,
        }}
        validationSchema={
          careerView
            ? ApplicationSchema
            : investorsView
            ? InvestorsSchema
            : landPurchaseView
            ? LandPurchaseSchema
            : ContactSchema
        }
        onSubmit={(values, { resetForm }) => {
          job && (values.job = job)
          values.ref = refferer
          values.flatID = id ? id : ""
          values.file = fileAdress
          if (gwView) {
            values.gw = gwView
          }
          //send mail
          if (!careerView && !investorsView && !landPurchaseView && !gwView) {
            const data = {
              name: values.name,
              email: values.email,
              flatID: id,
              messageContent: values.message,
              phone: values.phone,
              cameFrom: refferer,
            }
            let formdata = new FormData()
            formdata.append("eMail", values.email)
            formdata.append("name", values.name)
            formdata.append("text", values.message)
            formdata.append("phone", values.phone)
            formdata.append("flatID", values.flatID)
            formdata.append("cameFrom", refferer)
            let requestOptions = {
              method: "POST",
              body: formdata,
              redirect: "follow",
            }
            fetch(
              "https://panel.willbud.pl/upload_from_external_server/",
              requestOptions
            )
              .then(response => response.text())
              .then(result => console.log("RESULT", result))
              .catch(error => console.log("error", error))

            if (window.gtag_report_mailto_conversion) {
              window.gtag_report_mailto_conversion()
            }
          }
          fetch("/form-process.php", {
            method: "POST",
            body: JSON.stringify(values),
            mode: "cors",
            cache: "no-cache",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            redirect: "follow",
            referrer: "no-referrer",
          })
            .then(res => {
              resetForm()
              handleShowFormConfimation()
            })
            .catch(err => console.log(err))
        }}
      >
        {({ errors, touched, setFieldValue }) => (
          <Form>
            <div className="form-content">
              <h1>
                {careerView
                  ? intl.formatMessage({ id: "career.form.title" })
                  : investorsView
                  ? intl.formatMessage({ id: "form.title" })
                  : intl.formatMessage({ id: "form.title" })}
              </h1>
              <p className={"form-subtitle"}>
                {intl.formatMessage({ id: "form.content" })}
                <span>
                  {careerView
                    ? " praca@willbud.pl"
                    : investorsView
                    ? " inwestor@willbud.pl"
                    : landPurchaseView
                    ? " grunty@willbud.pl"
                    : gwView
                    ? " gw@willbud.pl"
                    : " sprzedaz@willbud.pl"}
                </span>
              </p>
              <div className="form-container">
                <Container fluid>
                  <Row>
                    <Col md={"12"} className={"input-column"}>
                      <div className={"input-wrapper"}>
                        <InputComponent
                          name="name"
                          style={
                            errors.name &&
                            touched.name && {
                              border: "2px solid #e00000",
                            }
                          }
                          placeholder={intl.formatMessage({
                            id: "form.input.name",
                          })}
                          icon={userIcon}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={"12"} className={"input-column"}>
                      <div className={"input-wrapper"}>
                        <InputComponent
                          name="phone"
                          style={
                            errors.phone &&
                            touched.phone && { border: "2px solid #e00000" }
                          }
                          placeholder={intl.formatMessage({
                            id: "form.input.tel",
                          })}
                          icon={phoneIcon}
                        />
                      </div>
                    </Col>
                    <Col md={"12"} className={"input-column"}>
                      <div className={"input-wrapper"}>
                        <InputComponent
                          name="email"
                          style={
                            errors.email &&
                            touched.email && { border: "2px solid #e00000" }
                          }
                          placeholder={intl.formatMessage({
                            id: "form.input.mail",
                          })}
                          icon={emailIcon}
                        />
                      </div>
                    </Col>
                    {landPurchaseView && (
                      <Col md={"12"} className={"input-column"}>
                        <div className={"input-wrapper"}>
                          <InputComponent
                            name="city"
                            style={
                              errors.city &&
                              touched.city && { border: "2px solid #e00000" }
                            }
                            placeholder={intl.formatMessage({
                              id: "landPurchase.form.input.city",
                            })}
                            icon={iconCity}
                          />
                        </div>
                      </Col>
                    )}
                    {landPurchaseView && (
                      <Col md={"12"} className={"input-column"}>
                        <div className={"input-wrapper"}>
                          <InputComponent
                            name="street"
                            style={
                              errors.street &&
                              touched.street && { border: "2px solid #e00000" }
                            }
                            placeholder={intl.formatMessage({
                              id: "landPurchase.form.input.street",
                            })}
                            icon={iconCity}
                          />
                        </div>
                      </Col>
                    )}
                    {investorsView && (
                      <Col md={"12"} className={"input-column"}>
                        <div className={"input-wrapper"}>
                          <InputComponent
                            name="amount"
                            style={
                              errors.amount &&
                              touched.amount && { border: "2px solid #e00000" }
                            }
                            icon={amountIcon}
                            select={true}
                            intl={intl}
                          />
                        </div>
                      </Col>
                    )}
                    {!careerView && (
                      <Col md={"12"} className={"input-column"}>
                        <div className={"input-wrapper"}>
                          <InputComponent
                            name={"message"}
                            component={"textarea"}
                            rows="6"
                            intl={intl}
                            id={id}
                            style={
                              errors.message &&
                              touched.message && {
                                border: "2px solid #e00000",
                              }
                            }
                            placeholder={intl.formatMessage({
                              id: "form.text.message.placeholder",
                            })}
                            icon={textIcon}
                            textarea={true}
                            build={build}
                          />
                        </div>
                      </Col>
                    )}
                    {careerView && (
                      <Col
                        md={12}
                        className={"input-column"}
                        style={{ marginBottom: "15px" }}
                      >
                        <div className="input-wrapper file-input-wrapper">
                          <div className="icon">
                            <img src={iconAttachment} alt="" />
                          </div>
                          <div className="file-input-box">
                            <label
                              style={{ height: fileName ? `70px` : "auto" }}
                            >
                              <Dropzone
                                multiple={false}
                                noDrag={true}
                                noClick="true"
                                noKeyboard="true"
                                noDragEventsBubbling={false}
                                onDropAccepted={acceptedFiles => {
                                  console.log("drop accepted")
                                  setFieldValue("file", acceptedFiles[0])
                                  onDropFiles(acceptedFiles[0])
                                }}
                              >
                                {({ getRootProps, getInputProps }) => (
                                  <section>
                                    <div {...getRootProps()}>
                                      <input
                                        className={"file-input"}
                                        {...getInputProps()}
                                      />
                                      <p>
                                        {intl.formatMessage({
                                          id: "career.form.input.cv",
                                        })}
                                      </p>
                                    </div>
                                  </section>
                                )}
                              </Dropzone>
                              <div style={{ height: "20px" }}>
                                {fileName
                                  ? `${intl.formatMessage({
                                      id: "career.form.input.cv.file",
                                    })} ${fileName}`
                                  : ""}
                              </div>
                            </label>
                            <div className="error-file">
                              <ErrorMessage name={"file"} />
                            </div>
                          </div>
                        </div>
                      </Col>
                    )}
                    <Col md={12} className={"input-column"}>
                      <p className={"checkbox-name"}>
                        {intl.formatMessage({ id: "form.agreement" })}
                      </p>
                    </Col>
                    {/*<Col md={12} className={"input-column"}>*/}
                    {/*  <div className="input-wrapper checkbox-input-wrapper">*/}
                    {/*    <div>*/}
                    {/*      <label>*/}
                    {/*        <input*/}
                    {/*          className={"checkbox-input"}*/}
                    {/*          name="rodo1"*/}
                    {/*          type="checkbox"*/}
                    {/*          onChange={event => {*/}
                    {/*            setFieldValue("rodo1", !values.rodo1)*/}
                    {/*          }}*/}
                    {/*        />*/}
                    {/*        <p className={"checkbox-name"}>*/}
                    {/*          Wyrażam zgodę na używanie przez WILLBUD SP. Z O.O.*/}
                    {/*          SP. K. danych osobowych dla celów marketingu*/}
                    {/*          bezpośredniego, aby przedstawić oferty WILLBUD SP.*/}
                    {/*          Z O.O. SP. K telefonicznie.*/}
                    {/*        </p>*/}
                    {/*      </label>*/}
                    {/*      <div className="error-message">*/}
                    {/*        <ErrorMessage name={"rodo1"} />*/}
                    {/*      </div>*/}
                    {/*    </div>*/}
                    {/*  </div>*/}
                    {/*</Col>*/}
                    <Col md={"12"} className={"button-column"}>
                      <MobileButton
                        innerText={intl.formatMessage({
                          id: "form.send.button",
                        })}
                        bg={"#9ecd49"}
                        color={"#fff"}
                        center={true}
                        handleAction={() => {
                          typeof window !== "undefined" &&
                            window.gtag_report_conversion &&
                            window.gtag_report_conversion()
                          typeof window !== "undefined" &&
                            window.fbq &&
                            window.fbq("track", "Lead")

                          window.gtag("event", "conversion", {
                            send_to: "AW-761411387/n2Y1CIapjd0CELvuiOsC",
                          })
                        }}
                      />
                      <ModalConfirmation
                        handleclose={handleCloseFormConfirmation}
                        show={formConfirmation}
                        onHide={handleCloseFormConfirmation}
                        investorsView={investorsView}
                        contactConfirmModal={true}
                      />
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </ContactFormStyled>
  )
}

export const InputComponent = ({
  name,
  placeholder,
  style,
  icon,
  textarea,
  build,
  id,
  select,
  intl,
}) => {
  return (
    <InputStyled textarea={textarea}>
      <label>
        {textarea && (
          <div className="textarea-head">
            <div className="icon icon-textarea">
              <img src={icon} alt="" />
            </div>
            <div>
              <p>{intl && intl.formatMessage({ id: "form.text.message" })}</p>
              <p>{id !== "false" && id}</p>
            </div>
          </div>
        )}
        <Field
          name={name}
          placeholder={placeholder}
          style={style}
          component={textarea ? "textarea" : select ? "select" : "input"}
          rows={7}
        >
          {select && (
            <>
              <option value="">
                {intl &&
                  intl.formatMessage({ id: "investors.form.input.amount" })}
              </option>
              <option value="50 000">50 000</option>
              <option value="100 000">100 000</option>
              <option value="200 000">200 000</option>
              <option value="500 000">500 000</option>
            </>
          )}
        </Field>
        {!textarea && (
          <div className="icon">
            <img src={icon} alt="" />
          </div>
        )}
      </label>
      <ErrorMessage
        component={"p"}
        className={"error-message"}
        style={textarea && { bottom: "-8px" }}
        name={name}
      />
    </InputStyled>
  )
}

const ModalConfirmation = props => {
  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable={false}
      dialogClassName={"contact-confirm-modal overflow-hidden"}
    >
      <ModalStyled>
        <div className="modal-container">
          <div className="close-button-area" onClick={props.handleclose}>
            <div className="close-button-modal" />
          </div>
          <div className="icon">
            {!props.investorsView && <img src={smile} alt="" />}
          </div>
          <div className="content">
            <p>Twoja wiadomość została wysłana</p>
            {!props.investorsView ? (
              <p>Dziękujemy za kontakt</p>
            ) : (
              <p>
                Skontaktujemy się z Tobą <br /> w ciągu 24h
              </p>
            )}
          </div>
        </div>
      </ModalStyled>
    </Modal>
  )
}

export default injectIntl(ContactForm)
